import { j as e } from '../../../_virtual/jsx-runtime.js';
import { TextLink as c } from '../TextLink/TextLink.js';
const d = ({
  clientName: t,
  links: s = [
    { text: 'Appliance care service plan terms and conditions', href: '#' },
    { text: `${t} Product Support`, href: '#' },
    { text: 'Terms of Use', href: '#' },
    { text: 'Domestic & General privacy notice', href: '#' },
    { text: `${t} privacy notice`, href: '#' },
    { text: 'Cookies notice', href: '#' },
  ],
  addendum: a = '',
}) =>
  /* @__PURE__ */ e.jsx('footer', {
    className: 'w-full text-xs bg-neutral-150 p-5 flex flex-col',
    children: /* @__PURE__ */ e.jsxs('div', {
      className:
        'w-full grid justify-items-start md:justify-items-center-safe gap-6 grid-cols-12 mx-auto w-10/12 sm:w-9/12 md:w-8/12  xl:max-w-container',
      children: [
        s &&
          s.length > 0 &&
          /* @__PURE__ */ e.jsx('nav', {
            className:
              'col-span-12 flex flex-col gap-2 justify-start md:flex-row flex-wrap md:justify-center md:gap-3 lg:gap-4',
            children: s.map((r, i) =>
              /* @__PURE__ */ e.jsx(
                'div',
                {
                  className: 'mb-2',
                  children: /* @__PURE__ */ e.jsx(c, { href: r.href, children: r.text }),
                },
                i,
              ),
            ),
          }),
        /* @__PURE__ */ e.jsxs('article', {
          className: 'text-left col-span-12',
          children: [
            /* @__PURE__ */ e.jsxs('p', {
              children: [
                t,
                ' Appliance Care service plans are provided by Domestic & General USA Services LLC. However, in Florida and Washington it is Domestic & General USA Inc. 866-333-3134, 230 East Avenue, Norwalk, CT, 06855. ',
                a,
              ],
            }),
            /* @__PURE__ */ e.jsx('br', {}),
            /* @__PURE__ */ e.jsx('p', {
              children:
                'This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.',
            }),
            /* @__PURE__ */ e.jsx('br', {}),
            /* @__PURE__ */ e.jsxs('p', {
              children: [
                ' © ',
                /* @__PURE__ */ new Date().getFullYear(),
                ' Domestic & General USA IP LLC ',
              ],
            }),
          ],
        }),
      ],
    }),
  });
export { d as Footer };
